import { Button, Modal } from "react-bootstrap"
import close from "../../../Assets/Icons/close2.png";
import { useEffect, useRef } from "react";

const MenuOutOfHourModal = ({menuName, setClickedId, setScheduleClick, setOpenMenuSchedule}) => {
    const modalRef = useRef(null);
    
    const handleClose = ()=>{
        setOpenMenuSchedule({state: false, data: ""});
        setClickedId("")
        setScheduleClick(false);
    }

    // Handle click outside the modal
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                handleClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div
            className="modal show"
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 1050
            }}
        >
            <div ref={modalRef}>
                <Modal.Dialog style={{ width: "370px" }}>
                    <Modal.Header className="d-flex align-items-center">
                        <Modal.Title>
                            <h5 style={{ fontWeight: "bold" }}>{menuName} Availability hours</h5>
                            <div className="unavailable-text food-status-text">Out of hours</div>
                        </Modal.Title>
                        <div className="close-btn" onClick={() => handleClose({state: false, data: ""})}>
                            <img src={close} alt="close" />
                        </div>
                    </Modal.Header>

                    <Modal.Body>
                        <table style={{ borderCollapse: "collapse", width: "100%" }}>
                            <thead>
                                <tr>
                                    <th
                                        style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        <h6 style={{ margin: 0 }}>Day / Date</h6>
                                    </th>
                                    <th
                                        style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        <h6 style={{ margin: 0 }}>Time</h6>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: "8px", textAlign: "center" }}>
                                        Sat - Tues
                                    </td>
                                    <td
                                        style={{
                                            borderRight: "none",
                                            padding: "8px",
                                            textAlign: "center",
                                        }}
                                    >
                                        09:00 AM - 09:00 PM
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "8px", textAlign: "center" }}>
                                        19 Feb 24
                                    </td>
                                    <td
                                        style={{
                                            borderRight: "none",
                                            padding: "8px",
                                            textAlign: "center",
                                        }}
                                    >
                                        09:00 AM - 11:00 PM
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "8px", textAlign: "center" }}>
                                        19 Feb 24
                                    </td>
                                    <td style={{ padding: "8px", textAlign: "center" }}>
                                        09:00 AM - 11:00 PM
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            variant="success"
                            style={{
                                backgroundColor: "transparent",
                                color: "green",
                                fontWeight: "bold",
                            }}
                            onClick={() => handleClose({state: false, data: ""})}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal.Dialog>
            </div>
        </div>
    )
}

export default MenuOutOfHourModal;